import * as React from 'react';
import { DefaultPalette, ICommandBarItemProps } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../system';
import { DateTime } from 'luxon';
import MessageCourier from '../../lib/MessageCourier';
import ViewWrapperWithCommandBar from '../Layout/ViewWrapperWithCommandBar';
import { defaultCommandBarButtonStyles, titleCommandBarButtonStyles } from '../../styles/button-styles';
import { ReportingFilters } from './ReportingFilters';
import { IReportCompanyData } from '../../system/reporting/ReportingSystem';
import { Company } from '../../system/company/Company';
import { useTranslation } from 'react-i18next';
import DataGrid, {
  Scrolling,
  Column,
  Grouping,
  GroupPanel,
  Summary,
  GroupItem,
  SortByGroupSummaryInfo,
  Export,
  SearchPanel,
  TotalItem,
  Toolbar,
  Item,
} from 'devextreme-react/data-grid';
import { EscalableExporterOptions, exportToExcel } from '../../lib/Util';
import Loading from '../Spinners/Loading';
import InfoHourDecimalTooltip from '../../shared/components/InfoHourDecimalTooltip';

interface IReportingSettlementHoursCompanies {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
}

export const ReportingSettlementHoursCompaniesDE = (props: IReportingSettlementHoursCompanies) => {
  const { t } = useTranslation();
  const [companySelected, setCompanySelected] = React.useState<Company|string>();
  const [from, setFrom] = React.useState<DateTime | undefined>(undefined);
  const [to, setTo] = React.useState<DateTime | undefined>(undefined);
  const [items, setItems] = React.useState<IReportCompanyData[]>([]);

/*   const [loading, setLoading] = React.useState<boolean>(true); */

/*   const load = async ()=>{
    try {
      await props.system.getCompanySystem().getList();
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  } */
  const itemsMenu = React.useMemo(
      (): ICommandBarItemProps[] => [
        {
          key: 'title',
          text: t('Reporte de horas por empresa'),
          iconProps: {
            iconName: 'ReminderPerson',
            color: DefaultPalette.themeLighterAlt,
            className: 'text-title-btn',
          },
          buttonStyles: titleCommandBarButtonStyles,
          className: 'text-title-btn',
        },
      ],
      []
  );

  const moneda = React.useMemo(() => {
    return items[0] ? items[0].moneda_simbolo : '';
  }, [items]);

  const onClickSearch = async () => {
    props.changeBlockUI(true);
    try {
      if (from && to) {
        const _items = await props.system.getReportingSystem().getCompanyReport(companySelected, from, to);
        const _mapped = _items.map((item, index) => {
          return {
            ...item,
            mockId: index + '',
          };
        });
        setItems(_mapped);
        props.courier.messageSuccess(t('Reporte generado con éxito'));
      } else {
        props.courier.messageError(t('Debes seleccionar un periodo'));
      }
    } catch (error) {
      props.courier.messageError(error);
    }
    props.changeBlockUI(false);
  };

  const onExporting = (e: any) => {
    let options: EscalableExporterOptions = {
      fileName: `reporte-horas-empresa-de-${from?.toFormat('dd-LL-yyyy')}-a-${to?.toFormat('dd-LL-yyyy')}`,
      sheetName: t('Reporte de horas por empresa'),
      customizeCell: (options) => {
        if (options.gridCell?.rowType === 'group') {
          options.excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '8DB4E2' } };
        }
        if (options.gridCell?.rowType === 'totalFooter' && options.excelCell.value) {
          options.excelCell.font.italic = true;
        }
      },
    };
    exportToExcel(e, options);
  };

/*   React.useEffect(() => {
    load();
  },[props.system])

  if(loading){
    return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
  }
 */
  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={""}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highligth"
      titleBody={t("Reporte de horas por empresa")}
    >
      <div className="report-filters-container bg-white">
          <ReportingFilters
            system={props.system}
            courier={props.courier}
            onChangeFromDate={(d) => {
              const fecha = d.toJSDate();
              const start = DateTime.fromJSDate(new Date(fecha.getFullYear(), fecha.getMonth(), 1));
              const end = DateTime.fromJSDate(new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0));
              setFrom(start);
              setTo(end);

            }}
            onChangeToDate={(d) => {}}
            onChangeCompany={(c) => setCompanySelected(c)}
            onClickSearch={onClickSearch}
            showCompanyFilter={true}
            showPeriodFilter={true}
          />
            {items.length > 0 && (
              // <div className="ms-Grid-row">
              //   <div className="ms-Grid-col ms-sm12">
              <DataGrid
                height={620}
                width="100%"
                keyExpr={"mockId"}
                dataSource={items}
                showBorders={true}
                wordWrapEnabled={true}
                onExporting={onExporting}
                className='mt-2'
              >
                <Scrolling mode="virtual" />
                <Export enabled={true} />
                <SearchPanel visible={true} placeholder={t("Buscar...")} />
                <Toolbar>
                  <Item
                    name="exportButton"
                    location="after"
                  />
                  <Item
                    name="searchPanel"
                    location="after"
                  />
                </Toolbar>
                {/* <Grouping autoExpandAll={false} /> */}
                {/* <GroupPanel visible={true} /> */}
                <Column
                  dataField="emp_nombre"
                  caption={t("Empresa")}
                  groupCellRender={(d) => {
                    return (
                      <div className="dx-datagrid-summary-item dx-datagrid-text-content dx-datagrid-group-text-content">
                        {d.value}
                      </div>
                    );
                  }}
                  /* groupIndex={0} */
                />
                {/* <Column
                  dataField="sector"
                  caption=""
                  groupCellRender={(d) => {
                    return (
                      <div className="dx-datagrid-summary-item dx-datagrid-text-content dx-datagrid-group-text-content">
                        {d.value}
                      </div>
                    );
                  }}
                  groupIndex={1}
                /> */}
                {/* <Column dataField="periodo" caption={t("Periodo")} /> */}
                {/* <Column
                  dataField="colaboradores_cant"
                  caption={t("Colaboradores")}
                  alignment={"center"}
                />
                <Column
                  dataField="horas_check_pending"
                  caption={t("Hs. pendientes")}
                  dataType="number"
                  alignment={"center"}
                  cellRender={(d) => {
                    return (
                      <div className="dx-datagrid-summary-item dx-datagrid-text-content dx-datagrid-group-text-content">
                        {d.value} Hs.
                      </div>
                    );
                  }}
                /> */}
                <Column
                  dataField="horas_chequeadas"
                  headerCellRender={() => {
                    return (
                      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}} >
                        {t("Hs. confirmadas")}
                        <InfoHourDecimalTooltip />
                      </div>
                    )
                  }}

                  dataType="number"
                  alignment={"center"}
                  cellRender={(d) => {
                    return (
                      <div className="dx-datagrid-summary-item dx-datagrid-text-content dx-datagrid-group-text-content">
                        {d.value} Hs.
                      </div>
                    );
                  }}
                />
                <Column
                  dataField="importe_costo"
                  caption={t("Costo")}
                  alignment={"center"}
                  cellRender={(d) => {
                    return (
                      <div className="dx-datagrid-summary-item dx-datagrid-text-content dx-datagrid-group-text-content">
                        {d.value} {moneda}
                      </div>
                    );
                  }}
                />
                <Summary>
                  <GroupItem
                    column="importe_costo"
                    summaryType="sum"
                    alignByColumn={true}
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    displayFormat={`{0} ${moneda}`}
                  />

                  <GroupItem
                    column="horas_chequeadas"
                    summaryType="sum"
                    alignByColumn={true}
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    displayFormat={`{0} hs.`}
                  />

                  <GroupItem
                    column="horas_chequeadas"
                    summaryType="sum"
                    displayFormat="{0} hs."
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    showInGroupFooter={true}
                  />
                  <GroupItem
                    column="importe_costo"
                    summaryType="sum"
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    displayFormat={`{0} ${moneda}`}
                    showInGroupFooter={true}
                  />
                  <TotalItem
                    column="importe_costo"
                    summaryType="sum"
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    displayFormat={`Total: {0} ${moneda}`}
                  />

                  <TotalItem
                    column="horas_chequeadas"
                    summaryType="sum"
                    valueFormat={(d) => parseFloat(d).toFixed(2)}
                    displayFormat={`Total: {0} hs.`}
                  />
                </Summary>
                <SortByGroupSummaryInfo sortOrder={"desc"} summaryItem="sum" />
              </DataGrid>
            )}
      </div>
    </ViewWrapperWithCommandBar>
  );
};
